var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isGroup())?_c('img',{style:(_vm.styleObject),attrs:{"src":require('@/assets/group.png'),"onerror":_vm.onerror()}}):(this.avatar)?_c('img',{style:(_vm.styleObject),attrs:{"src":_vm.avatarUrl,"onerror":_vm.onerror()}}):_c('img',{style:(_vm.styleObject),attrs:{"src":require("@/assets/default_avatar.jpg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }